/**
 * @author Yakov.Gushchin
 * @version 1.0.0
 */
import moment from 'moment';

import cx from './cx';
import * as dates from './dates';

const unitType = {
    DAY: 'DAY',
    WEEK: 'WEEK',
    MONTH: 'MONTH',
    QUARTER: 'QUARTER',
    YEAR: 'YEAR',
};

const interval = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
};

const positions = {
    LEFT: 'left',
    RIGHT: 'right',
};


export const getDefaultState = () => {
    const calendar = moment();
    const minDate = calendar.clone().subtract(5, 'year');
    const maxDate = calendar.clone().add(5, 'year');
    const maxSpan = { years: 5 };
    const autoApply = true;
    const singleDatePicker = false;
    const showDropdowns = true;
    const closedOrOpen = interval.CLOSED;
    const minYear = calendar
        .clone()
        .subtract(5, 'year')
        .format('YYYY');
    const maxYear = calendar
        .clone()
        .add(2, 'year')
        .format('YYYY');
    const showWeekNumbers = false;
    const showISOWeekNumbers = false;
    const showCustomRangeLabel = true;
    const timePicker = false;
    const timePicker24Hour = false;
    const timePickerIncrement = 1;
    const timePickerSeconds = false;
    const alwaysShowCalendars = false;
    const ranges = {};
    const opens = 'left';
    const drops = 'down';
    const buttonClasses = 'btn btn-sm';
    const applyButtonClasses = 'btn-primary';
    const cancelButtonClasses = 'btn-default';
    const isInvalidDate = () => false;
    const isCustomDate = () => [];
    const linkedCalendars = true;

    return {
        calendar,
        minDate,
        maxDate,
        maxSpan,
        showDropdowns,
        minYear,
        maxYear,
        showWeekNumbers,
        showISOWeekNumbers,
        timePicker,
        timePickerIncrement,
        timePicker24Hour,
        timePickerSeconds,
        ranges,
        showCustomRangeLabel,
        alwaysShowCalendars,
        opens,
        drops,
        singleDatePicker,
        linkedCalendars,
        buttonClasses,
        applyButtonClasses,
        cancelButtonClasses,
        autoApply,
        isInvalidDate,
        isCustomDate,
        closedOrOpen,
    };
};

export {
    dates,
    cx,
    unitType,
    interval,
    positions,
}
